export default __webpack_public_path__ + "static/First-a33a97ff7c2b651fec399183a3e6e8c1.jpg";